import React from 'react';
import { SparklesIcon, ArrowRightIcon } from 'lucide-react';
export function Hero() {
  const handleBookCall = () => {
    window.open('https://calendly.com', '_blank');
  };
  const companyLogos = [{
    name: 'TechVision',
    color: 'from-blue-500 to-cyan-500',
    letter: 'T'
  }, {
    name: 'DataFlow',
    color: 'from-purple-500 to-pink-500',
    letter: 'D'
  }, {
    name: 'CloudSync',
    color: 'from-green-500 to-teal-500',
    letter: 'C'
  }, {
    name: 'NexusAI',
    color: 'from-orange-500 to-red-500',
    letter: 'N'
  }];
  return <div className="relative bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 text-white overflow-hidden" data-id="element-110">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-111">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-112"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32" data-id="element-113">
        <div className="text-center max-w-4xl mx-auto" data-id="element-114">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8" data-id="element-115">
            <SparklesIcon className="w-4 h-4" data-id="element-116" />
            <span className="text-sm font-medium" data-id="element-117">
              100% AI-Powered Go-to-Market
            </span>
          </div>
          {/* Main headline */}
          <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight" data-id="element-118">
            Scale Your Revenue with
            <span className="block bg-gradient-to-r from-yellow-200 to-pink-200 bg-clip-text text-transparent" data-id="element-119">
              AI-Powered Marketing
            </span>
          </h1>
          {/* Subheadline */}
          <p className="text-xl lg:text-2xl text-blue-100 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-120">
            From branding to pipeline generation, we run your entire
            go-to-market engine with AI. Flat fee + success fee, so you only
            scale when it works.
          </p>
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-121">
            <button onClick={handleBookCall} className="group bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 flex items-center gap-2" data-id="element-122">
              Book Your Strategy Call
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-123" />
            </button>
            <button className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all" data-id="element-124">
              See Pricing
            </button>
          </div>
          {/* Social proof */}
          <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-8 text-blue-100" data-id="element-125">
            <div className="flex items-center gap-3" data-id="element-126">
              <div className="flex -space-x-3" data-id="element-127">
                {companyLogos.map((company, i) => <div key={i} className={`w-12 h-12 rounded-lg bg-gradient-to-br ${company.color} border-2 border-white flex items-center justify-center font-bold text-white shadow-lg`} title={company.name} data-id="element-128">
                    {company.letter}
                  </div>)}
              </div>
              <span className="text-sm font-medium" data-id="element-129">50+ companies scaled</span>
            </div>
            <div className="text-sm" data-id="element-130">
              <span className="font-bold text-white text-2xl" data-id="element-131">3.2x</span>{' '}
              average ROI in 6 months
            </div>
          </div>
        </div>
      </div>
      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-132">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-133">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" data-id="element-134" />
        </svg>
      </div>
    </div>;
}